export const GET_ROLES = `
query($page:ID!, $q:String) {
  roles(page: $page, q:$q) {
    count
    results{
      id
      name
      users {
        id
        name
      }
    }
    errors{
      description
    }
  }
}
`;

export const GET_ROLE_SUMMARY = `
  query GetRole($id:ID!) {
    role(id: $id ){
      users {
        id
        name
      }
    }
  }
`;

export const ALL_ROLES_QUERY = `
  query {
    roles {
      results {
        id
        name
      }
    }
  }
`;

export const CREATE_ROLE = `
  mutation createRole($name:String!) {
    createRole(name: $name){
      role {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_ROLE_WITH_ENTITLEMENTS = `
  query GetRole($id:ID!) {
    role(id: $id ){
      id
      name
      users {
        id
        name
        email
      }
      entitlements {
        id
        name
      }
    }
  }
`;

export const DELETE_ROLE = `
  mutation DeleteRole($id:ID!) {
    deleteRole(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;


export const UPDATE_ROLE = `
  mutation UpdateRole($id:ID!, $name: String!) {
    updateRole(id: $id, name: $name ){
      role {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }

`;
